module.exports = __webpack_public_path__ + "img/dentalicon-3.fb5dc28e.png";